<div class="search-component">
    <input
        type="text"
        class="search-input w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        [placeholder]="placeholder"
        [value]="value"
        (input)="onInputChange($event)"
        (keypress)="onKeyPress($event)" />
</div>
